<div style="margin: 20px;">

  <div class="box-container">
    <div class="box-header">
      <span>{{ 'content.red_flags' | translate }}</span>
    </div>
    <div class="box-item" style="text-align: center">
      <span class="text-blue-color" style="font-size: 16px">
        <strong>{{'content.red_flags_to_look_out_for_in_email_content' | translate}}</strong>
      </span>
    </div>
    <div class="box-item">
      <span class="text-blue-color">
        {{'content.expected_email' | translate}}
      </span>
    </div>
    <div class="box-item">
      <span class="ms-2">
          {{'content.content_warning' | translate}}
      </span>
    </div>
    <div class="box-item">
      <span class="text-blue-color">
        {{ 'content.continuity' | translate }}
      </span>
    </div>
    <div class="box-item">
      <span class="ms-2">
        {{ 'content.email_tone_check' | translate }}
      </span>
    </div>
    <div class="box-item">
      <span class="text-blue-color">
        {{ 'content.spelling_and_grammar' | translate }}
      </span>
    </div>
    <div class="box-item">
      <span class="ms-2">
        {{ 'content.email_language_check' | translate }}
      </span>
    </div>
    <div class="box-item">
      <span class="text-blue-color">
        Urgency
      </span>
    </div>
    <div class="box-item">
      <span class="ms-2">
        {{ 'content.email_urgency_check' | translate }}
      </span>
    </div>
  </div>

  <div class="box-container">
    <div class="box-header">
      <span>{{'content.best_practices' | translate }}</span>
    </div>
    <div class="box-item" style="text-align: center">
      <span class="text-blue-color" style="font-size: 16px">
        <strong>{{ 'content.content_suspicious' | translate }}</strong>
      </span>
    </div>
    <div class="box-item">
      <span class="text-blue-color">
        Reach out
      </span>
    </div>
    <div class="box-item">
      <span class="ms-2">
          {{'content.email_verification_suggestion' | translate}}
      </span>
    </div>
    <div class="box-item">
      <span class="text-blue-color">
        Coworkers
      </span>
    </div>
    <div class="box-item">
      <span class="ms-2">
        {{'content.email_team_check' | translate}}
      </span>
    </div>
    <div class="box-item">
      <span class="text-blue-color">
        Report
      </span>
    </div>
    <div class="box-item">
      <span class="ms-2">
          {{'content.email_report_security' | translate}}
      </span>
    </div>
  </div>
</div>
